/**
 * THE RETIRED v1 MARKETING ROUTES (launch-marketing-pages design M1 "The v1
 * marketing routes retire"; spec `public-marketing-pages` scenario "An old
 * feature link lands on Home").
 *
 * `/why/:featureId` and `/solutions` were the v1 marketing pages. Home and the
 * Owner page replace them, and their components are deleted. The addresses are
 * still in old posts, emails and bookmarks, so each one lands on Home rather
 * than falling through to the unmatched-path arm.
 *
 * ── THE PARAMS ARE NEVER READ ───────────────────────────────────────────────
 * The guard takes no argument, so it cannot read the route, its params or its
 * query, as `retiredAuthRoutes.js` does. That is also why it is a guard and not
 * a bare `redirect:`: vue-router's redirect copies `to.params`, `to.query` and
 * `to.hash` into a named target, so `/why/freedom?horizontalTab=…` would carry
 * a dead `featureId` and a workspace address onto Home. A location returned
 * from a guard carries only what it names. The `:featureId` segment stays in
 * the path only so an old link still MATCHES a record.
 *
 * ── WHY THE RECORDS CARRY NO NAME AND NO META ───────────────────────────────
 * Nothing pushes these destinations: the names `WhyTowerHunt` and
 * `SolutionsShell` are gone with their views. The records exist for the PATHS
 * only, as the retired password and `/admin` records do. They declare no
 * `surfaceTheme`: they render no surface of their own, and Home follows the
 * theme. Home's own `beforeEnter` (the root fate) still runs on the landing,
 * so a member who opens an old link from outside lands where `/` lands them.
 */

/** The retired paths. */
export const RETIRED_MARKETING_PATHS = Object.freeze(["/why/:featureId", "/solutions"]);

/**
 * Send the navigation to Home. Takes nothing, so it reads nothing of the route
 * it retires.
 *
 * @returns {{ name: string }} Home's route.
 */
export function landOnHome() {
  return { name: "Home" };
}

/**
 * The route records, built from the one list.
 *
 * @param {object|Function} placeholderComponent — never rendered; the guard
 *   always redirects. A record with neither component nor children warns at
 *   build.
 * @returns {Array<object>} vue-router route records.
 */
export function retiredMarketingRouteRecords(placeholderComponent) {
  return RETIRED_MARKETING_PATHS.map((path) => ({
    path,
    beforeEnter: () => landOnHome(),
    component: placeholderComponent,
  }));
}
